export default __webpack_public_path__ + "static/media/new_kingdom_2_1x.7366abf2.webp";